import React from 'react';
import { FormattedMessage } from 'react-intl';
import { call } from './../utilities/http';
import Address from './../models/address';
import { LOADING, SAVING, COMPLETE, ADDRESSES_GET_OK, ADDRESSES_GET_SINGLE_OK, ADDRESSES_SAVE_OK, ADDRESSES_DELETE_OK } from './types';
import { Snackbar } from '../components/snackbar';

const defaultState = {
    list: undefined,
    draft: undefined
};

/**
 * Loading state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case ADDRESSES_GET_OK:
            return { ...state, list: action.data };

        case ADDRESSES_GET_SINGLE_OK:
            return { ...state, draft: action.data };

        case ADDRESSES_SAVE_OK:
            let addresses = state.list ? state.list.filter(a => a.id !== action.data.id) : [];
            return { ...state, list: [...addresses, action.data], draft: action.data };

        case ADDRESSES_DELETE_OK:
            return { ...state, list: state.addresses.filter(a => a.id !== action.data) };

        default:
            return state;
    }
}

export function saveAddress(values, onSuccess = response => null, onError = error => null) {
    let address = new Address(values);
    let action = address.id ? updateAddress : createAddress;
    return action(address, onSuccess, onError);
}

function createAddress(address, onSuccess, onError) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/address`, method: 'POST', body: address })
            .then(response => {
                dispatch({ type: ADDRESSES_SAVE_OK, data: { ...address, ...response } });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

function updateAddress(address, onSuccess, onError) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/address/${address.id}`, method: 'PUT', body: address })
            .then(response => {
                dispatch({ type: ADDRESSES_SAVE_OK, data: address });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function deleteAddress(id, onSuccess = () => null, onError = error => Snackbar.error(error)) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/address/${id}`, method: 'DELETE' })
            .then(response => {
                dispatch({ type: ADDRESSES_DELETE_OK, data: id });
                dispatch({ type: COMPLETE });
                onSuccess();
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getAddresses(role, onSuccess = response => null) {
    let { type, id } = role;
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/${type}/${id}/addresses` })
            .then(response => {
                dispatch({ type: ADDRESSES_GET_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.companyAddresses'} defaultMessage={'Unable to retrieve company addresses.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

export function getAddress(id) {
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/address/${id}` })
            .then(response => {
                dispatch({ type: ADDRESSES_GET_SINGLE_OK, data: response });
                dispatch({ type: COMPLETE });
            })
            .catch(error => {
                Snackbar.error(<FormattedMessage id={'error.companyAddress'} defaultMessage={'Unable to retrieve company address.'} />);
                dispatch({ type: COMPLETE });
            });
    };
}

export function saveLocation(location, onSuccess = () => null, onError = error => Snackbar.error(error)) {
    return async function(dispatch) {
        dispatch({ type: SAVING });
        let locationData = new Address(location);
        call({ path: `/address`, method: 'POST', body: locationData })
            .then(response => {
                onSuccess(response);
                dispatch({ type: COMPLETE });
            })
            .catch(error => {
                onError(error);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/addresses.jsx